var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { initializeStripePaymentElements } from "./paymentElements.mjs";
import { initializeStripeExpressElements } from "./expressElements.mjs";
import { initializeStripeBillingAddressElements } from "./billingAddressElements.mjs";
import { initializeStripeShippingAddressElements } from "./shippingAddressElements.mjs";
export const expressCheckoutElementId = 'stripe-express-checkout-container';
export const shippingAddressElementId = 'stripe-shipping-address-container';
export const billingAddressElementId = 'stripe-billing-address-container';
export const paymentElementId = 'stripe-payment-container';
export const initializeStripeElements = (state, actions, cartCheckout, cartPayment, elements) => __awaiter(void 0, void 0, void 0, function* () {
    initializeStripeExpressElements(state, actions, cartPayment, cartCheckout);
    initializeStripeShippingAddressElements(state, actions, elements);
    initializeStripeBillingAddressElements(state, actions, elements);
    initializeStripePaymentElements(state, actions, cartPayment, elements);
});
export const paymentIntentClientSecret = (state) => {
    validateStripeCheckoutPayment(state);
    return state.checkout.payment.elements.paymentIntentClientSecret;
};
function validateStripeCheckoutPayment(state) {
    var _a, _b;
    if (((_b = (_a = state.checkout) === null || _a === void 0 ? void 0 : _a.payment) === null || _b === void 0 ? void 0 : _b.$type) !== 'stripeCheckout') {
        state.onUnexpectedError('Invalid payment type');
        throw new Error('Invalid payment type');
    }
}
//# sourceMappingURL=elements.js.map